module.exports = __webpack_public_path__ + "static/img/how3.2fc1e07e.png";